import { show } from '@intercom/messenger-js-sdk';
import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import Chat from '../../ui/icons/chat'; import FeaturedLink from '../../ui/links/featured';


const TalkToUsButton = ({ variant }: { variant?: string | null }) => {
  const { t } = useTranslation();

  return (
    <FeaturedLink
      variant={variant || 'blackbold'}
      className="font-bold text-[14pt] flex flex-row gap-1 w-fit items-center"
      onClick={show}
    >
      <Chat className={cx('inline-block', 'align-middle', 'h-4', 'w-4', 'text-neutral-80')} />{' '}
      <span className='text-neutral-80'>{t('help:chat-online')}</span>
    </FeaturedLink>
  );
};

const TalkToUs = ({ variant }: { variant?: string | null }) => {
  return <TalkToUsButton variant={variant} />;
};

export default TalkToUs;
